import React, { useState } from 'react';
import * as Fi from 'react-icons/fi';
import { FaFacebook, FaInstagram, FaThreads } from 'react-icons/fa6';
import PricingModal from './PricingModal.jsx';

const Footer = ({ hideButton = false, centered = false }) => {
  const [showPricing, setShowPricing] = useState(false);

  return (
    <>
      <div
        className={`shrink-0 flex items-center z-20 relative px-4 ${
          centered ? 'justify-center' : 'justify-between'
        }`}
        style={{
          height: '2rem',
          background: 'rgba(2,6,23,0.72)',
          borderTop: '1px solid rgba(255,255,255,0.06)',
        }}
      >
        <div className="flex items-center gap-2">
          <p
            className={`text-[10px] font-bold tracking-wide ${
              centered ? 'text-center' : ''
            }`}
            style={{ color: 'rgba(255,255,255,0.45)' }}
          >
            用心製作,獻給每一場精彩球賽 ·{' '}
            <a
              href="https://homy.hk"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'rgba(255,255,255,0.65)', textDecoration: 'none' }}
              onMouseEnter={(e) => (e.target.style.color = 'rgba(255,255,255,0.95)')}
              onMouseLeave={(e) => (e.target.style.color = 'rgba(255,255,255,0.65)')}
            >
              Homy Tech Limited
            </a>
          </p>

          {/* Social Media Icons */}
          <div className="flex items-center gap-1.5">
            <a
              href="https://www.facebook.com/profile.php?id=61578745554661"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/40 hover:text-blue-400 transition-colors"
              title="Facebook"
              style={{ fontSize: '12px' }}
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/homy.hk"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/40 hover:text-pink-400 transition-colors"
              title="Instagram"
              style={{ fontSize: '12px' }}
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.threads.com/@homy.hk"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/40 hover:text-white transition-colors"
              title="Threads"
              style={{ fontSize: '12px' }}
            >
              <FaThreads />
            </a>
          </div>
        </div>

        {!hideButton && (
          <div className={centered ? 'absolute right-4' : ''}>
            <button
              onClick={() => setShowPricing(true)}
              className="text-[9px] font-black px-2 py-1 rounded-md bg-indigo-500/20 text-indigo-300 border border-indigo-500/30 hover:bg-indigo-500/30 transition-all tracking-wide"
            >
              💝 贊助
            </button>
          </div>
        )}
      </div>

      <PricingModal open={showPricing} onClose={() => setShowPricing(false)} />
    </>
  );
};

export default Footer;